import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24f52d3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  opacity: ".502",
  fill: "#272A42",
  d: "M321.999.999h-46s-8.755-.235-18 10c0 0-4.005 17.986-29 18h-152s-19.005-3.264-24 13L0 212.999h321.999v-212z"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "top-header__title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", {
    class: "top-header",
    style: _normalizeStyle({ height: _ctx.height })
  }, [
    (_openBlock(), _createElementBlock("svg", {
      style: _normalizeStyle([_ctx.$route.name === 'Order' && { visibility: 'hidden' }]),
      class: "top-header__bg",
      xmlns: "http://www.w3.org/2000/svg"
    }, _hoisted_2, 4)),
    (_ctx.$route.meta.title)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.$route.meta.title), 1))
      : _createCommentVNode("", true)
  ], 4))
}